import { render, staticRenderFns } from "./cabinet_detail.vue?vue&type=template&id=dc383644&scoped=true&"
import script from "./cabinet_detail.vue?vue&type=script&lang=js&"
export * from "./cabinet_detail.vue?vue&type=script&lang=js&"
import style0 from "./cabinet_detail.vue?vue&type=style&index=0&id=dc383644&prod&scoped=true&lang=css&"
import style1 from "./cabinet_detail.vue?vue&type=style&index=1&id=dc383644&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc383644",
  null
  
)

export default component.exports